import React, { ReactElement } from 'react'
import Icon, { IconName } from '../../Common/Components/Icon'
import { IconSize } from '../../../NonReact/constants/React/Icon/Constants'
// Commons imports.
// CSS imports. Commented out because of current build process.
// import './promptMessageWithWarning.scss';

/**
 * Component properties type.
 */
export type PromptMessageWithWarningProps = {
    message: string
    warningMessage: string
}

/**
 * Inline configurable prompt component with message and additional warning message below.
 *
 * @param message Message to be displayed.
 * @param warningMessage Warning message content to be displayed.
 */
const PromptMessageWithWarning: React.FC<PromptMessageWithWarningProps> = ({
    message,
    warningMessage
}: PromptMessageWithWarningProps): ReactElement => (
    <div className='prompt-message-with-warning'>
        <div className='message'>{message}</div>
        <div className='warningMessage'>
            <Icon iconName={IconName.HELP} iconSize={IconSize.LARGE} />
            {warningMessage}
        </div>
    </div>
)

export default PromptMessageWithWarning
